import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import LineAnalyticsListing from '@/modules/dashboard/components/LineAnalytics/components/LineAnalyticsListing'
import useQueryGetLineAnalytics from '@/modules/dashboard/api/hooks/useQueryGetLineAnalytics'
import { useDate } from '@/common/hooks/useDate'
import { Card, CardContent } from '@/common/ui/card'

function LineAnalyticsPage() {
	const { date } = useDate()

	const payload = {
		date: date || undefined,
	}

	const { data, isLoading } = useQueryGetLineAnalytics(payload)

	// Show empty state when success is false
	if (!isLoading && data && data.success === false) {
		return (
			<PageContainer>
				<Card>
					<CardContent className="py-12">
						<div className="flex flex-col items-center justify-center text-center">
							<p className="text-lg font-semibold text-muted-foreground">
								ไม่พบข้อมูล
							</p>
							<p className="mt-2 text-sm text-muted-foreground">
								ไม่ได้ทำการผูก LINE Messaging API กับ AUTO
							</p>
						</div>
					</CardContent>
				</Card>
			</PageContainer>
		)
	}

	return (
		<PageContainer>
			<LineAnalyticsListing data={data} isLoading={isLoading} />
		</PageContainer>
	)
}

const GuardedLineAnalyticsPage = withUserPermission(LineAnalyticsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_MARKETING],
})

export default GuardedLineAnalyticsPage
